import type { FaireProductEntity } from "../../entity_types/product";

export const p_mbmz9nmtyf: FaireProductEntity = {
  token: "p_mbmz9nmtyf",
  type: "product",
  name: "Mike's Pastry Boston - Storefront Art Print - New England",
  brandToken: "b_2nlyab4cca",
  brandName: "Sarah Wormann Art",
  imageUrl: "https://cdn.faire.com/fastly/5c1d9e09db97a022315ecb69d9cdfe52717e59280c201ed5255007400b979585.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/353fa93326ac5ceae61b5b52fbdf75d97d0e73fd5296a7d8a6a03b83c0ae5373.jpeg",
    "https://cdn.faire.com/fastly/c9e8000fd98c9034e03ef2216da3cf9d5351522e806b721b1503d73819aae519.jpeg",
    "https://cdn.faire.com/fastly/ed79f30c52af69e5a367ebaef74c4cfa96f35cb553148b063c2b4bd5954b8c5e.jpeg",
    "https://cdn.faire.com/fastly/bf5697043371c95ed784e01c63906029d411af0141e36857b3d1be5d9279db8f.jpeg",
    "https://cdn.faire.com/fastly/f3ec5472e883c7875cf2ee2415f6d6bc6bfdc787a7963cdaa770e150f460bfb5.jpeg",
    "https://cdn.faire.com/fastly/4763efe55ed89a65264473d820fe40e96b341409271ed67913a5889881ed208c.jpeg"
  ],
  priceDollars: 10,
  description: "Fine art print of Mike's Pastry in Boston, Massachusetts, originally created with gouache and ink.\n\nAll art prints are painted, printed, and packaged by Sarah in her home studio in Boston, MA.\n\n\n𝐏𝐫𝐢𝐧𝐭 𝐝𝐞𝐭𝐚𝐢𝐥𝐬:\n• Printed on archival paper using pigment inks for crisp details and vibrant colors that will last years and years\n• Hand-signed in pencil\n\n𝐒𝐢𝐳𝐞𝐬:\n• Available sizes: 5”x7”, 8”x10”, 11”x14”\n• Print sizes fit standard frames\n\n𝐏𝐚𝐜𝐤𝐚𝐠𝐢𝐧𝐠 𝐚𝐧𝐝 𝐬𝐡𝐢𝐩𝐩𝐢𝐧𝐠:\n• Each print is packaged in a clear sleeve with cardboard backing, ready to display\n• Orders are shipped in a rigid mailer or cardboard box\n• All prints are unframed",
  tags: [],
  msrpDollars: 20,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-09T08:04:13.164Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
